export const getSiteSchedulesRoute = () => '/schedules';
export const getSiteScheduleEditRoute = (scheduleId = null) => '/schedules/' + (scheduleId ?? ':scheduleId');
export const getSiteEventsRoute = () => '/events';
export const getSiteEventEditRoute = (eventId = null) => '/events/' + (eventId ?? ':eventId');
export const getSiteEventLiveRoute = (eventId = null) => '/events/' + (eventId ?? ':eventId') + '/live';
export const getSiteEventChatOverlayRoute = (eventId = null) => '/events/' + (eventId ?? ':eventId') + '/overlay/chat';